import React, { createContext, useContext, useState } from 'react';

// Create the context
export const DataContext = createContext();

// Provider component
export const DataProvider = ({ children }) => {
  const [sharedData, setSharedData] = useState(0);
  const [storage, setStorage] = useState(0);

  const value = {
    sharedData,
    setSharedData,
    storage,
    setStorage,
  };

  return (
    <DataContext.Provider value={value}>
      {children}
    </DataContext.Provider>
  );
};

// Custom hook to use the context
export const useData = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error('useData must be used within a DataProvider');
  }
  return context;
};

export default DataContext;
